module.exports = __webpack_public_path__ + "static/media/arrow_down.6ed1f2c9.svg";